module.exports = __webpack_public_path__ + "static/media/store icon 2.86b2a498.png";